import { render } from "./CarouselChamp.vue?vue&type=template&id=28c685b1&scoped=true"
import script from "./CarouselChamp.vue?vue&type=script&lang=js"
export * from "./CarouselChamp.vue?vue&type=script&lang=js"

import "./CarouselChamp.vue?vue&type=style&index=0&id=28c685b1&scoped=true&lang=css"

import exportComponent from "E:\\Dev\\Univ\\vueQuizzly\\node_modules\\vue-loader\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-28c685b1"]])

export default __exports__